import { z } from "zod";

/**
 * The one field a picker types when saying how many of a carrier go along.
 *
 * Zero is allowed, and means the line is removed — a carrier is the picker's own decision, unlike
 * an article line the order owes whether they like it or not, so unmaking it has to be as easy as
 * making it. There is no upper bound: the yard balance is shown beside the field and never
 * enforced, because a picker loading more than the system believed was there is reporting a
 * miscount rather than making a mistake.
 */
export const carrierQuantitySchema = z.object({
	quantity: z.coerce.number().int().min(0),
});

export type CarrierQuantityFormSchema = z.infer<typeof carrierQuantitySchema>;
